import React from 'react';
import { useAssistantContext } from './Provider';
import TheModal from '../Modal';
import Content from './Content';
import Icon from '../Icons/Icon';
import { classNames } from '../../Services/helpers';
import { useSession } from '../Session';

const Mobile = () => {
    const {isAdmin, isAdminSwitched} = useSession();
    const {mobileStyle} = useAssistantContext();

    if (!isAdmin()) {
        return null;
    }

    if (isAdminSwitched) {
        return null;
    }

    return mobileStyle === 'floating' ? <Floating /> : <Modal />
}

const Floating = () => {
    const {assistantOpen, setAssistantOpen, toggleMobileStyle} = useAssistantContext();

    return (
        <div className={classNames(
            'fixed bottom-20 end-0 ml-8 mr-3 mb-5',
            'flex flex-col',
            'transition-all duration-300',
            assistantOpen ? 'h-[60vh] w-[90vw] opacity-100' : 'h-0 w-0 opacity-0',
            'z-50',
            // !assistantOpen && 'd-none'
        )}>
            <div className="relative w-full">
                <div className="float-right w-fit p-2 mb-1 bg-sky-50/50 backdrop-blur-sm border shadow-xl rounded-full">
                    <div className="flex flex-row justify-end items-center gap-4">
                        <Icon icon="ArrowsDiagonalOut"
                            size="1x"
                            className="fill-muted"
                            onClick={() => toggleMobileStyle()}
                        />
                        <Icon icon="XMark"
                            size="1.5x"
                            className="fill-muted"
                            onClick={() => setAssistantOpen(false)}
                        />
                    </div>
                </div>
            </div>
            <div className="relative w-full h-full">
                <div className="absolute top-0 start-0 end-0 h-full w-full bg-gradient-to-br from-sky-100/50 to-white/50 bg-opacity-50 backdrop-blur-md border shadow-xl rounded-lg" />
                <div className="absolute top-0 start-0 end-0 h-full w-full bg-transparent">
                    {assistantOpen && <Content />}
                </div>
            </div>
        </div>
    );
}

const Modal = () => {
    const {assistantOpen, setAssistantOpen, toggleMobileStyle} = useAssistantContext();

    const collapseBtn = <Icon icon="ArrowsDiagonalIn"
        size="1x"
        className="fill-muted"
        onClick={() => toggleMobileStyle()}
    />;

    return <TheModal title="Sidekick" isOpen={assistantOpen} setIsOpen={setAssistantOpen} extraBtn={collapseBtn} dismissible>
        <div className="h-[80vh] overflow-hidden">
            {assistantOpen && <Content />}
        </div>
    </TheModal>
}

export default Mobile;
